var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
export class GenericMouseEvent {
}
export class FromTypes {
}
FromTypes.POWERPOINT = 'powerpoint';
FromTypes.EXCEL = 'excel';
FromTypes.WORD = 'word';
FromTypes.PDF = 'pdf';
FromTypes.IMAGE = 'image';
FromTypes.PS = 'ps';
FromTypes.VIDEO = 'video';
FromTypes.AUDIO = 'audio';
FromTypes.AV = 'av';
FromTypes.EBOOK = 'ebook';
FromTypes.ARCHIVE = 'archive';
FromTypes.FILES = 'files';
FromTypes.TEXT = 'text';
export var ConvertType;
(function (ConvertType) {
    ConvertType["Convert"] = "convert";
    ConvertType["Compress"] = "compress";
    ConvertType["Split"] = "split";
    ConvertType["Merge"] = "merge";
    ConvertType["All"] = "all";
    ConvertType["Resize"] = "resize";
    ConvertType["Meme"] = "meme";
    ConvertType["Count"] = "count";
    ConvertType["Encode"] = "encode";
    ConvertType["Decode"] = "decode";
    ConvertType["Crop"] = "crop";
    ConvertType["Trim"] = "trim";
    ConvertType["Cut"] = "cut";
})(ConvertType || (ConvertType = {}));
export class ToTypes {
}
ToTypes.POWERPOINT = 'powerpoint';
ToTypes.WORD = 'word';
ToTypes.PDF = 'pdf';
ToTypes.IMAGE = 'image';
ToTypes.PS = 'ps';
ToTypes.PNG = 'png';
ToTypes.JPG = 'jpg';
ToTypes.TIFF = 'tiff';
ToTypes.WEBP = 'webp';
ToTypes.VIDEO = 'video';
ToTypes.AUDIO = 'audio';
ToTypes.EBOOK = 'ebook';
ToTypes.JPEG = 'jpeg';
ToTypes.HEIC = 'heic';
export class ProcessTypes {
}
ProcessTypes.CONVERT = 'convert';
ProcessTypes.COMPRESS = 'compress';
ProcessTypes.EXTRACT = 'extract';
ProcessTypes.ARCHIVE = 'archive';
ProcessTypes.SPLIT = 'split';
ProcessTypes.MERGE = 'merge';
ProcessTypes.RESIZE = 'resize';
ProcessTypes.CROP = 'crop';
ProcessTypes.ENCODE = 'encode';
ProcessTypes.DECODE = 'decode';
ProcessTypes.COUNT = 'count';
ProcessTypes.URL_ENCODER = 'url-encoder';
ProcessTypes.URL_DECODER = 'url-decoder';
ProcessTypes.BASE64_ENCODE = 'base64-encode';
ProcessTypes.BASE64_DECODE = 'base64-decode';
ProcessTypes.WORD_COUNT = 'word-count';
ProcessTypes.MEME = 'meme';
ProcessTypes.FORMAT = 'format';
ProcessTypes.MINIFY = 'minify';
ProcessTypes.VALIDATE = 'validate';
ProcessTypes.TEST = 'test';
ProcessTypes.LOOKUP = 'lookup';
ProcessTypes.CALCULATE = 'calculate';
export class StatusTypes {
}
StatusTypes.COMPLETED = 'completed';
StatusTypes.STARTED = 'started';
StatusTypes.FAILED = 'failed';
StatusTypes.UNDEFINED = 'undefined';
export class ProcessStageSubStateTypes {
}
ProcessStageSubStateTypes.STARTED = 'started';
ProcessStageSubStateTypes.PARTIAL = 'partial';
ProcessStageSubStateTypes.FAILED = 'failed';
ProcessStageSubStateTypes.UNKNOWN = 'unknown';
ProcessStageSubStateTypes.COMPLETED = 'completed';
export class ProcessStageTypes {
}
ProcessStageTypes.UPLOAD = 'upload';
ProcessStageTypes.QUEUED = 'queued';
ProcessStageTypes.PREPROCESS = 'preprocess';
ProcessStageTypes.PROCESSING = 'processing';
ProcessStageTypes.READY = 'ready';
ProcessStageTypes.ZIP = 'zip';
ProcessStageTypes.COMPLETED = 'completed';
export class DataTypes {
}
DataTypes.PERCENTAGE = 'percentage';
DataTypes.RATIO = 'ratio';
DataTypes.NOTIFICATION = 'notification';
export class WebsocketProcessTypes {
}
WebsocketProcessTypes.CONVERT_ONE_TO_ONE = 'convert-one-to-one';
WebsocketProcessTypes.CONVERT_ONE_TO_MANY = 'convert-one-to-many';
export class OriginalInputFileLocationTypes {
}
OriginalInputFileLocationTypes.LOCAL = 'local';
OriginalInputFileLocationTypes.GSC = 'gcs';
export class PSFileTypes {
}
PSFileTypes.GOOGLE_DRIVE_FILE = 'GOOGLE_DRIVE_FILE';
PSFileTypes.DROPBOX_FILE = 'DROPBOX_FILE';
PSFileTypes.FILE = 'FILE';
export class PSUploadTypes {
}
PSUploadTypes.SERVER = 'server';
PSUploadTypes.GOOGLE_CLOUD_STORAGE = 'gcs';
export class OperationTypes {
}
OperationTypes.UPLOAD = 'upload';
OperationTypes.PROCESS = 'process';
OperationTypes.GENERIC = 'generic';
export var FileMetadata;
(function (FileMetadata) {
    function getFileIdFromSafeName(safeName) {
        const parts = safeName.split(/\-|\./);
        let tokenCount = parts.length - 1;
        while (tokenCount >= 0) {
            if (parts[tokenCount].length === 24) {
                return parts[tokenCount];
            }
            tokenCount--;
        }
        throw new Error('Failed to get uploaded file id from the given safe file name.');
    }
    FileMetadata.getFileIdFromSafeName = getFileIdFromSafeName;
})(FileMetadata || (FileMetadata = {}));
export class URLType {
}
URLType.LOCAL_RELATIVE = 'local-relative';
URLType.LOCAL_ABSOLUTE = 'local-absolute';
URLType.REMOTE = 'remote';
export class Packages {
}
Packages.PACKAGE_TYPE_BASIC = 'PACKAGE_TYPE_BASIC';
Packages.PACKAGE_TYPE_PRO = 'PACKAGE_TYPE_PRO';
export class MotiveLocationTypes {
}
MotiveLocationTypes.appPageTop = 'appPageTop';
MotiveLocationTypes.singlePageBaseTop = 'singlePageBaseTop';
MotiveLocationTypes.singlePageBaseLeft = 'singlePageBaseLeft';
MotiveLocationTypes.singlePageBaseRight = 'singlePageBaseRight';
MotiveLocationTypes.fileUploadPageTop = 'fileUploadPageTop';
MotiveLocationTypes.fileUploadPageBottom = 'fileUploadPageBottom';
MotiveLocationTypes.fileDownloadPageTop = 'fileDownloadPageTop';
MotiveLocationTypes.fileDownloadPageWithInCurrentDownloads = 'fileDownloadPageWithInCurrentDownloads';
MotiveLocationTypes.fileDownloadPageWithInRecoveredDownloads = 'fileDownloadPageWithInRecoveredDownloads';
MotiveLocationTypes.fileDownloadPageBottom = 'fileDownloadPageBottom';
MotiveLocationTypes.fileDownloadPageLeft = 'fileDownloadPageLeft';
MotiveLocationTypes.fileDownloadPageRight = 'fileDownloadPageRight';
MotiveLocationTypes.homePageTop = 'homePageTop';
MotiveLocationTypes.memePageTop = 'memePageTop';
MotiveLocationTypes.convertPageTop = 'convertPageTop';
MotiveLocationTypes.convertPageBelowFeatureTitle = 'convertPageBelowFeatureTitle';
MotiveLocationTypes.convertPageLeft = 'convertPageLeft';
MotiveLocationTypes.convertPageRight = 'convertPageRight';
MotiveLocationTypes.convertPageBottom = 'convertPageBottom';
MotiveLocationTypes.howToPageTop = 'howToPageTop';
export class MotiveSlotConfig {
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "appPageTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "singlePageBaseTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "singlePageBaseLeft", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "singlePageBaseRight", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileUploadPageTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileUploadPageBottom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileDownloadPageTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileDownloadPageWithInCurrentDownloads", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileDownloadPageWithInRecoveredDownloads", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileDownloadPageBottom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileDownloadPageLeft", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "fileDownloadPageRight", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "homePageTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "memePageTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "convertPageTop", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], MotiveSlotConfig.prototype, "convertPageBelowFeatureTitle", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "convertPageLeft", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "convertPageRight", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "convertPageBottom", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], MotiveSlotConfig.prototype, "howToPageTop", void 0);
export class MotiveConfig extends MotiveSlotConfig {
    constructor() {
        super();
    }
}
export class MotiveSettingsResponse {
}
export class FromTypeFileSizeLimitInMB {
}
export class UserLimitsSettings extends FromTypeFileSizeLimitInMB {
}
export class FeatureFlags {
}
export class PaymentStateTypes {
}
PaymentStateTypes.unknown = 'unknown';
PaymentStateTypes.signup = 'signup';
PaymentStateTypes.paid = 'paid';
PaymentStateTypes.cancelled = 'cancelled';
export class PaymentGatewayTypes {
}
PaymentGatewayTypes.none = 'none';
PaymentGatewayTypes.paypal = 'paypal';
PaymentGatewayTypes.stripe = 'stripe';
export class AccountDetails {
    isPaidUser() {
        const now = Date.now();
        const v2Active = (this.entitlementsCache ?? []).some((e) => {
            if (e?.type !== 'WEBSITE')
                return false;
            if (e.state !== 'ACTIVE' && e.state !== 'CANCELED_ACCESS_UNTIL_PERIOD_END')
                return false;
            if (!e.activeUntil)
                return true;
            const until = e.activeUntil instanceof Date ? e.activeUntil : new Date(e.activeUntil);
            return until.getTime() > now;
        });
        if (v2Active)
            return true;
        return (this.packageType === Packages.PACKAGE_TYPE_BASIC ||
            this.packageType === Packages.PACKAGE_TYPE_PRO) &&
            (this.paid ||
                ((this.subscriptionNextBillingDate && this.subscriptionNextBillingDate.getTime() > now - 1000 * 60 * 60 * 24 * 1)));
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], AccountDetails.prototype, "createdDate", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], AccountDetails.prototype, "lastUpdatedDate", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], AccountDetails.prototype, "subscriptionNextBillingDate", void 0);
export class UserSettings {
}
__decorate([
    Type(() => FromTypeFileSizeLimitInMB),
    __metadata("design:type", FromTypeFileSizeLimitInMB)
], UserSettings.prototype, "highPriorityCountryFromTypeFileSizeLimitInMB", void 0);
__decorate([
    Type(() => FromTypeFileSizeLimitInMB),
    __metadata("design:type", FromTypeFileSizeLimitInMB)
], UserSettings.prototype, "fromTypeFileSizeLimitInMB", void 0);
__decorate([
    Type(() => UserLimitsSettings),
    __metadata("design:type", UserLimitsSettings)
], UserSettings.prototype, "freeUserLimits", void 0);
__decorate([
    Type(() => UserLimitsSettings),
    __metadata("design:type", UserLimitsSettings)
], UserSettings.prototype, "basicUserLimits", void 0);
__decorate([
    Type(() => UserLimitsSettings),
    __metadata("design:type", UserLimitsSettings)
], UserSettings.prototype, "proUserLimits", void 0);
__decorate([
    Type(() => MotiveSettingsResponse),
    __metadata("design:type", MotiveSettingsResponse)
], UserSettings.prototype, "motive", void 0);
